import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Paper,
  Typography,
  Avatar,
} from "@mui/material";
import { ToastContainer, toast, Zoom } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import PellifixTextLogo from "../../../assets/2.svg";
import PellifixSubTextLogo from "../../../assets/3.svg";
import axios from "axios";
import { API } from "../../../utils/apiEndpoints";
import authorization from "../../../utils/authorization";
import { getApiErrorMessage } from "../../../utils/apiError";

const MainSection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const isAssociatelogin =
    location && location.pathname && location.pathname === "/associates/login";
  const isSubOrdinatelogin =
    location && location.pathname && location.pathname === "/employee/login";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [emailFormatError, setEmailFormatError] = useState(false);

  const validateForm = () => {
    let isValid = true;
    if (!email) {
      setEmailError(true);
      isValid = false;
    } else if (email && !/\S+@\S+\.\S+/.test(email)) {
      setEmailFormatError(true);
      isValid = false;
    }
    if (!password) {
      isValid = false;
      setPasswordError(true);
    } else {
      isValid = true;
    }
    return isValid;
  };

  const handleClickLogin = () => {
    console.log("register");
    // navigate("/register");
    if (validateForm()) {
      setLoading(true);
      let api;
      if (isAssociatelogin) {
        api = API.associateLogin;
      } else if (isSubOrdinatelogin) {
        api = API.subOrdinateLogin;
      } else {
        api = API.customerLogin;
      }

      const values = {
        email_id: email,
        password: password,
      };
      validateUserLogin(values, api);
    }
  };

  const validateUserLogin = (values, api) => {
    axios
      .post(api, { ...values })
      .then((response) => {
        if (response && response.status == 200) {
          authorization.login(response.data);
          setLoading(false);
          toast.success("Login Successfully!", {
            position: "top-right",
            autoClose: 1500,
            theme: "colored",
            transition: Zoom,
          });
          setTimeout(() => {
            if (isAssociatelogin) {
              navigate("/auth/associates/view-profile");
            } else if (isSubOrdinatelogin) {
              navigate("/auth/employee/home");
            } else {
              navigate("/auth/home");
            }
          }, 1000);
        }
      })
      .catch((err) => {
        toast.error(getApiErrorMessage(err, "Unable to log in"), {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
          transition: Zoom,
        });
        setLoading(false);
      });
  };

  return (
    <>
      <Box
        data-aos="fade-up"
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        width={{
          md: "100%",
          sm: "100%",
          xs: "100%",
        }}
        height={"100%"}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 1,
            width: "100%",

            maxWidth: 450,
          }}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Avatar
              alt="Pellifix"
              src={PellifixTextLogo}
              sx={{
                width: 120,
                // height: 80,
              }}
            />
            <Avatar
              alt="Pellifix"
              src={PellifixSubTextLogo}
              sx={{
                width: 150,
                // height: 80,
              }}
            />
            {/* <Box
              component="img"
              alt="pellifix"
              src={Logo}
              sx={{
                width: 120,
                height: 80,
                objectFit: "contain",
              }}
            /> */}
            {/* <Typography color="primary">Welcome to Pellifix</Typography> */}
            <Typography variant="body2" color="textSecondary">
              Find your perfect partner today!
            </Typography>
          </Box>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              paddingX: 2,
              py: 3,
              borderRadius: 4,
              display: "grid",
            }}
            gap={2}
          >
            <TextField
              id="outlined-basic"
              label="Email"
              variant="outlined"
              size="small"
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setEmailError(false);
                setEmailFormatError(false);
              }}
              error={emailError || emailFormatError}
              helperText={
                emailError
                  ? "Email is required"
                  : emailFormatError
                    ? "Please enter a valid email address"
                    : ""
              }
            />
            <TextField
              id="outlined-basic"
              label="Password"
              variant="outlined"
              size="small"
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setPasswordError(false);
              }}
              error={passwordError}
              helperText={passwordError ? "Password is required" : ""}
            />

            {/* <TextField
              sx={{
                bgcolor: "#fff",
                width: "100%",
              }}
              id="outlined-basic"
              label="Name"
              variant="outlined"
              size="small"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />

            <TextField
              id="outlined-basic"
              label="Mobile"
              variant="outlined"
              size="small"
              type="tel"
              value={phone}
              onChange={(e) => {
                if (e.target.value.match(/^[0-9]*$/)) {
                  if (e.target.value.length <= 10) setPhone(e.target.value);
                }
              }}
            />
            <TextField
              id="outlined-basic"
              label="Email"
              variant="outlined"
              size="small"
              type="email"
            />
            <Grid2 container>
              <Grid2
                item
                size={{
                  md: 6,
                  sm: 6,
                  xs: 12,
                }}
              >
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    pr: 1,
                  }}
                >
                  <InputLabel id="demo-simple-select-label">Gender</InputLabel>

                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={gender}
                    onChange={(e) => {
                      setGender(e.target.value);
                    }}
                    fullWidth
                    size="small"
                    label="Gender"
                  >
                    <MenuItem value={0} disabled>
                      Select Gender
                    </MenuItem>
                    <MenuItem value={1}>Male</MenuItem>
                    <MenuItem value={2}>Female</MenuItem>
                  </Select>
                </FormControl>
              </Grid2>
              <Grid2
                item
                size={{
                  md: 6,
                  sm: 6,
                  xs: 12,
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer
                    components={["DatePicker"]}
                    sx={{
                      paddingTop: 0,
                      overflow: "hidden",
                    }}
                  >
                    <DatePicker
                      value={DOB}
                      onChange={(newValue) => setDOB(newValue)}
                      disableFuture
                      showMonthYearPicker
                      showMonthDropdown
                      slotProps={{
                        textField: { size: "small", width: "90%" },
                      }}
                      format="DD/MM/YYYY"
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Grid2>
              <Grid2
                item
                size={{
                  md: 6,
                  sm: 6,
                  xs: 12,
                }}
                mt={2}
              >
                <TextField
                  id="outlined-basic"
                  label="Password"
                  variant="outlined"
                  size="small"
                  type="password"
                  sx={{
                    pr: 1,
                  }}
                  va
                />
              </Grid2>
              <Grid2
                item
                size={{
                  md: 6,
                  sm: 6,
                  xs: 12,
                }}
                mt={2}
              >
                <TextField
                  id="outlined-basic"
                  label="Confirm Password"
                  variant="outlined"
                  size="small"
                  type="password"
                />
              </Grid2>
              <Grid2 item size={12} mt={2}>
                <TextField
                  id="outlined-basic"
                  label="Referal Code"
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              </Grid2>
            </Grid2>
            <FormControlLabel
              control={<Checkbox checked={isTermsAndCondition} />}
              label={
                <Typography fontSize={14}>
                  By proceeding, I agree to Pellifix
                  <NavLink to={"/terms-and-conditions"}>
                    Terms and conditions
                  </NavLink>
                  .
                </Typography>
              }
              name="is_agreement"
              onChange={() => setIsTermsAndCondition(!isTermsAndCondition)}
            />

            <Button
              className="button"
              // type="submit"
              variant="contained"
              color="primary"
              onClick={() => handleClickRegister()}
            >
              <Typography color="#fff"> Register Free</Typography>
            </Button> */}
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleClickLogin()}
              loading={loading ? true : false}
            >
              <Typography color="#fff"> Login </Typography>
            </Button>

            <Button
              variant="text"
              size="small"
              sx={{ justifySelf: "end", textTransform: "none", p: 0 }}
              onClick={() =>
                navigate(
                  isAssociatelogin
                    ? "/associates/forgot-password"
                    : isSubOrdinatelogin
                      ? "/employee/forgot-password"
                      : "/forgot-password",
                )
              }
            >
              Forgot Password?
            </Button>

            <Typography>
              Don't have an account yet?{" "}
              <Typography
                component="span"
                color="primary"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/register")}
              >
                Join Pellifix
              </Typography>{" "}
            </Typography>
          </Box>
        </Paper>
      </Box>
      <ToastContainer />
    </>
  );
};
export default MainSection;
